exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container {\n    /* margin-right: auto;\n    margin-left: auto; */\n    width: 100%;\n    /* margin: 0 auto; */\n}\n.panel2, .panel21 {\n    background: #fcfcfc;\n    border: solid 1px #dbdbdb;\n    /*margin-bottom: 5%;*/\n    padding-bottom: 25px;\n    padding-top: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    float: left;\n    width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fe38b7e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/CMEditRemindSetting.vue
// module id = 1137
// module chunks = 2